"use client";

import dynamic from "next/dynamic";
import { Suspense } from "react";

/**
 * Chargement différé de MapLibre (~210 Ko gzip) : jamais dans le bundle
 * initial, uniquement à l'ouverture de la page carte.
 */
const IslandMap = dynamic(() => import("./IslandMap"), {
  ssr: false,
  loading: () => (
    <div className="skeleton grid h-full w-full place-items-center" role="status">
      <span className="text-sm text-mineral">Chargement de la carte…</span>
    </div>
  ),
});

export default function MapLoader() {
  return (
    // Suspense requis : IslandMap lit useSearchParams (deep link ?lieu=)
    <Suspense
      fallback={
        <div className="skeleton grid h-full w-full place-items-center" role="status">
          <span className="text-sm text-mineral">Chargement de la carte…</span>
        </div>
      }
    >
      <IslandMap />
    </Suspense>
  );
}
